const termReasons = [
	"Member Requested",
	"Loss/Gain of Other Coverage",
	"Voluntary Termination of Employment",
	"Involuntary Termination of Employment",
	"Reduction of Hours",
	"Death of the Employee",
	"Employee's Medicare Entitlement",
	"Divorce or Legal Seperation",
	"A Dependent Child ceasing to be a Dependent",
	"The bankruptcy of the Employer"
];

export const TERM_REASONS = termReasons;

export const BENEFIT_TERM_REASONS = [
	"Member Requested",
	"Benefit Termination due to Non-Payment",
	"Loss/Gain of Other Coverage",
	"Voluntary Termination of Employment",
	"Involuntary Termination of Employment",
	"Reduction of Hours",
	"Death of the Employee",
	"Employee's Medicare Entitlement",
	"Divorce or Legal Seperation",
	"A Dependent Child ceasing to be a Dependent",
	"The bankruptcy of the Employer"
];

export const DEPENDENT_BENEFIT_TERM_REASONS = [
	"Dependent has reached the maximum eligible age for coverage.",
	"Dependent has obtained employer-sponsored health insurance.",
	"Dependent is eligible for another health insurance plan.",
	"Dependent no longer meets the criteria for dependency.",
	"Dependent is no longer eligible due to divorce or legal separation.",
	"Dependent has passed away.",
	"Dependent is deemed ineligible due to a legal order or court decision.",
	"Employee voluntarily chooses to drop the dependent from the plan"
];
